import React from "react";
import { getTranslations } from "../../../../Helper/TranslationController";

const TrainingCell = React.memo(({ value, overrideClass, translations }) => {
  if (!value) return null;
  return (
    <div className={`custom-formation-training-cell ${overrideClass || ""}`}>
      <span className="custom-formation-training-cell_label">
        {getTranslations(value.name, translations)}
      </span>
    </div>
  );
});

export default TrainingCell;
